<script>
import convert from 'xml-js'
export default {
  name: 'xmlUtils',
  methods: {
    getParseObjectFromXml (xml) {
      const json = convert.xml2json(xml, { compact: true })
      return JSON.parse(json)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/utils/XmlUtils.vue